import { teamRoles } from "../../constants/teamRoles";
import runTransaction from "../../utils/runTransaction";

import offerStatuses from "./constants/offerStatuses";
import offerTypes from "./constants/offerTypes";
import createOfferData from "./createOfferData";

export default async function createVoiceOffer(
	firebase,
	{ user, price, production, voiceId = 1, status, createdBy },
	{ transaction } = {},
) {
	const offer = createOfferData(firebase, {
		id: `${production.id}-${user.id}-${teamRoles.READER}`,
		role: teamRoles.READER,
		type: offerTypes.INQUIRY,
		price: price?.price
			? {
					unit: "hour",
					type: "reader",
					price: +price?.price || 0,
					currency: price?.currency || "SEK",
			  }
			: null,
		status: status || offerStatuses.INITIAL,
		approved: true,
		production,
		secondParty: user,
		createdBy,
	});

	await runTransaction(
		firebase,
		[],
		(transaction) => {
			transaction.set(offer.ref, offer);

			transaction.set(
				production.ref,
				{
					voices: {
						[voiceId]: {
							readerIds: firebase.firestore.FieldValue.arrayUnion(offer.secondParty.id),
						},
					},
					...(offer.secondParty.name && {
						voiceNames: firebase.firestore.FieldValue.arrayUnion(offer.secondParty.name),
					}),
				},
				{ merge: true },
			);
		},
		transaction,
	);

	return offer;
}
